import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUserTenantGroupLevel implements BaseEnumType {
  private static allValues: EnumUserTenantGroupLevel[] = []; // make sure this is top-most
  
  public static member = new EnumUserTenantGroupLevel(0, "Member", "enum_user_tenant_group_level_member");
  public static administrator = new EnumUserTenantGroupLevel(1, "Administrator", "enum_user_tenant_group_level_administrator");
  public static superAdministrator = new EnumUserTenantGroupLevel(2, "SuperAdministrator", "enum_user_tenant_group_level_super_administrator");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUserTenantGroupLevel.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isMember() { return this === EnumUserTenantGroupLevel.member; }
  public isAdministrator() { return this === EnumUserTenantGroupLevel.administrator; }
  public isSuperAdministrator() { return this === EnumUserTenantGroupLevel.superAdministrator; }

  public static getValues(): readonly EnumUserTenantGroupLevel[] {
    return EnumUserTenantGroupLevel.allValues;
  }

  public static getValuesExcept0(): readonly EnumUserTenantGroupLevel[] {
    return EnumUserTenantGroupLevel.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUserTenantGroupLevel {
    const found = EnumUserTenantGroupLevel.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUserTenantGroupLevel - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUserTenantGroupLevel): EnumUserTenantGroupLevel {
    const found = name ? EnumUserTenantGroupLevel.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUserTenantGroupLevel - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUserTenantGroupLevel>): boolean {
    return this.key === other?.key;
  }
}